import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index.vue'
import Ping from '@/views/Ping.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/ping',
      name: 'ping',
      component: Ping
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js